import axios from "axios";
import { axiosInstance } from "./AxiosInstance";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function mfaSetupRequest(payload: any) {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/v1/auth/mfa/setup`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function mfaSetupValidateRequest(payload: any) {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/v1/auth/mfa/setup/validate`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function mfaValidateRequest(payload: any) {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/v1/auth/mfa/validate`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function addInternalUserRequest(userPayload: any) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/users`,
      userPayload
    );
    return response;
  } catch (error) {
    // console.log("Error - ", error);
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateUserRequest(userPayload: any) {
  try {
    const { id, ...payload } = userPayload;
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/users/${id}`,
      payload
    );
    return response;
  } catch (error) {
    // console.log("Error - ", error);
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function deactivateUserRequest(id: string) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/users/${id}/deactivate`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function reactivateUserRequest(id: string) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/users/${id}/reactivate`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateCurrentUserRequest(userPayload: any) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/users/current-user`,
      userPayload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function resetCurrentUserPasswordRequest(userPayload: any) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/users/current-user/reset-password`,
      userPayload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function resetPasswordWithTokenRequest(payload: {
  resetToken: string;
  password: string;
}) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/auth/reset-password`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function addRole(payload: any) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/roles`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateRole(payload: any) {
  const { id, ...data } = payload;
  try {
    const response = await axiosInstance.patch(
      `${API_BASE_URL}/api/v1/roles/${id}`,
      data
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function deleteRole(id: string) {
  try {
    const response = await axiosInstance.delete(
      `${API_BASE_URL}/api/v1/roles/${id}`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function duplicateRole(id: string) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/roles/${id}/duplicate`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function assignPermission(payload: any) {
  const { id, ...data } = payload;
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/roles/${id}/permissions`,
      data
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateUserRolesRequest(userPayload: any) {
  try {
    const { id, ...payload } = userPayload;
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/users/${id}/roles`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function addClientRequest(payload: any) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/clients`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateClientDetailsRequest(payload: any) {
  const { id, ...data } = payload;
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/clients/${id}`,
      data
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateClientContactsRequest(payload: any) {
  const { id, ...data } = payload;
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/clients/${id}/contacts`,
      data
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateClientSFSContactsRequest(payload: any) {
  const { id, ...data } = payload;
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/clients/${id}/contacts/internal`,
      data
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function deactivateClientRequest(id: string) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/clients/${id}/deactivate`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function activateClientRequest(payload: any) {
  const { id, ...data } = payload;
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/clients/${id}/reactivate`,
      data
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function uploadClientLogoRequest(
  clientId: string,
  logoFile: File
) {
  try {
    const formData = new FormData();
    formData.append("logo", logoFile);

    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/clients/${clientId}/logo`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function uploadInspectionFirmLogoRequest(
  inspectionFirmId: string,
  logoFile: File
) {
  try {
    const formData = new FormData();
    formData.append("logo", logoFile);

    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/inspectors/${inspectionFirmId}/logo`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function addClientSubDivisionRequest(
  clientId: string,
  payload: any
) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/clients/${clientId}/sub-divisions`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateClientDivisionDetailsRequest(
  clientId: string,
  divisionId: string,
  payload: any
) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/clients/${clientId}/sub-divisions/${divisionId}`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateClientDivisionContactsRequest(
  clientId: string,
  divisionId: string,
  payload: any
) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/clients/${clientId}/sub-divisions/${divisionId}/contacts`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function deleteClientDivisionRequest(
  clientId: string,
  divisionId: string,
  payload: any
) {
  try {
    const response = await axiosInstance.delete(
      `${API_BASE_URL}/api/v1/clients/${clientId}/sub-divisions/${divisionId}`,
      { data: payload }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function clientDivisionActivateRequest(
  clientId: string,
  divisionId: string
) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/clients/${clientId}/sub-divisions/${divisionId}/reactivate`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function clientDivisionDeactivateRequest(
  clientId: string,
  divisionId: string,
  payload: any
) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/clients/${clientId}/sub-divisions/${divisionId}/deactivate`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function uploadClientDocumentRequest(
  clientId: string,
  documentFile: File
) {
  try {
    const formData = new FormData();
    formData.append("document", documentFile);

    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/clients/${clientId}/documents`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function deleteClientDocumentRequest(
  clientId: string,
  documentKey: string
) {
  try {
    const response = await axiosInstance.delete(
      `${API_BASE_URL}/api/v1/clients/${clientId}/documents?documentKey=${documentKey}`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateInspectionFirmDetailsRequest(payload: any) {
  const { id, ...data } = payload;
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/inspectors/${id}`,
      data
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateInspectionFirmContactsRequest(payload: any) {
  const { id, ...data } = payload;
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/inspectors/${id}/contacts`,
      data
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateInspectionFirmSFSContactsRequest(payload: any) {
  const { id, ...data } = payload;
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/inspectors/${id}/contacts/internal`,
      data
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function addInspectionFirmRequest(payload: any) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/inspectors`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateProcedureCancellationRequest(
  clientId: string,
  payload: any
) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/clients/${clientId}/procedures`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateTaxDetailsRequest(payload: any) {
  const { id, ...data } = payload;
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/inspectors/${id}/tax-details`,
      data
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateOrderHandlingRequest(
  clientId: string,
  payload: any
) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/clients/${clientId}/notification-events`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateInspectorRequirementsRequest(
  clientId: string,
  payload: any
) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/clients/${clientId}/inspection-restrictions`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function getInspectionFirmsListRequest() {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/api/v1/inspectors/list`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateServicesFeesRequest(
  clientId: string,
  payload: any
) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/clients/${clientId}/services-fees`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateInsuranceDetailsRequest(
  inspectionFirmId: string,
  payload: any
) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/inspectors/${inspectionFirmId}/insurances`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateServicesDetailsRequest(payload: any) {
  const { id, ...data } = payload;
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/inspectors/${id}/services`,
      data
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateCurrentServicesDetailsRequest(payload: any) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/inspectors/current/services`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function addFormTemplateRequest(payload: any) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/formtemplates`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateFormTemplateRequest(
  templateId: string,
  payload: any
) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/formtemplates/${templateId}`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateFormTemplateDocumentRequest(
  templateId: string,
  documentFile: File
) {
  try {
    const formData = new FormData();
    formData.append("form", documentFile);

    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/formtemplates/${templateId}/document`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function replaceFormTemplateDocumentRequest(
  templateId: string,
  documentFile: File
) {
  try {
    const formData = new FormData();
    formData.append("form", documentFile);

    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/formtemplates/${templateId}/document/replace`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function addCoverageAreaRequest(
  inspectionFirmId: string,
  payload: any
) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/inspectors/${inspectionFirmId}/coverage-areas`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateCoverageAreaRequest(
  inspectionFirmId: string,
  payload: any
) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/inspectors/${inspectionFirmId}/coverage-areas/${payload.id}`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function deleteCoverageAreaRequest(
  inspectionFirmId: string,
  payload: any
) {
  try {
    const response = await axiosInstance.delete(
      `${API_BASE_URL}/api/v1/inspectors/${inspectionFirmId}/coverage-areas/${payload.id}`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function uploadInspectionFirmDocumentRequest(
  inspectorId: string,
  documentFile: File
) {
  try {
    const formData = new FormData();
    formData.append("document", documentFile);

    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/inspectors/${inspectorId}/documents`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function deleteInspectionFirmDocumentRequest(
  inspectorId: string,
  documentKey: string
) {
  try {
    const response = await axiosInstance.delete(
      `${API_BASE_URL}/api/v1/inspectors/${inspectorId}/documents?documentKey=${documentKey}`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function downloadTemporaryFileRequest(key: string) {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/api/v1/files/download`,
      {
        params: { key },
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response as any;
    }
  }
}

export async function updateCertificationDetailsRequest(
  id: string,
  payload: any
) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/users/${id}/certifications`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function addFormSectionRequest(
  templateId: string,
  payload: any,
  isClient: boolean
) {
  try {
    let response;
    if (isClient) {
      response = await axiosInstance.post(
        `${API_BASE_URL}/api/v1/forms/${templateId}/sections`,
        payload
      );
    } else {
      response = await axiosInstance.post(
        `${API_BASE_URL}/api/v1/formtemplates/${templateId}/sections`,
        payload
      );
    }

    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateFormSectionRequest(
  templateId: string,
  sectionId: string,
  payload: any,
  isClient: boolean
) {
  try {
    let response;
    if (isClient) {
      response = await axiosInstance.put(
        `${API_BASE_URL}/api/v1/forms/${templateId}/sections/${sectionId}`,
        payload
      );
    } else {
      response = await axiosInstance.put(
        `${API_BASE_URL}/api/v1/formtemplates/${templateId}/sections/${sectionId}`,
        payload
      );
    }
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function deleteFormSectionRequest(
  templateId: string,
  sectionId: string,
  isClient: boolean
) {
  try {
    let response;
    if (isClient) {
      response = await axiosInstance.delete(
        `${API_BASE_URL}/api/v1/forms/${templateId}/sections/${sectionId}`
      );
    } else {
      response = await axiosInstance.delete(
        `${API_BASE_URL}/api/v1/formtemplates/${templateId}/sections/${sectionId}`
      );
    }
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function reOrderFormSectionRequest(
  templateId: string,
  sectionId: string,
  index: number,
  isClient: boolean
) {
  try {
    let response;
    if (isClient) {
      response = await axiosInstance.put(
        `${API_BASE_URL}/api/v1/forms/${templateId}/sections/${sectionId}/reorder/${index}`
      );
    } else {
      response = await axiosInstance.put(
        `${API_BASE_URL}/api/v1/formtemplates/${templateId}/sections/${sectionId}/reorder/${index}`
      );
    }
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function addFormSectionElementRequest(
  templateId: string,
  sectionId: string,
  payload: any,
  isClient: boolean
) {
  try {
    let response;
    if (isClient) {
      response = await axiosInstance.post(
        `${API_BASE_URL}/api/v1/forms/${templateId}/sections/${sectionId}/elements`,
        payload
      );
    } else {
      response = await axiosInstance.post(
        `${API_BASE_URL}/api/v1/formtemplates/${templateId}/sections/${sectionId}/elements`,
        payload
      );
    }
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateFormSectionElementRequest(
  templateId: string,
  sectionId: string,
  elementId: string,
  payload: any,
  isClient: boolean
) {
  try {
    let response;
    if (isClient) {
      response = await axiosInstance.put(
        `${API_BASE_URL}/api/v1/forms/${templateId}/sections/${sectionId}/elements/${elementId}`,
        payload
      );
    } else {
      response = await axiosInstance.put(
        `${API_BASE_URL}/api/v1/formtemplates/${templateId}/sections/${sectionId}/elements/${elementId}`,
        payload
      );
    }
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function deleteFormSectionElementRequest(
  templateId: string,
  sectionId: string,
  elementId: string,
  isClient: boolean
) {
  try {
    let response;
    if (isClient) {
      response = await axiosInstance.delete(
        `${API_BASE_URL}/api/v1/forms/${templateId}/sections/${sectionId}/elements/${elementId}`
      );
    } else {
      response = await axiosInstance.delete(
        `${API_BASE_URL}/api/v1/formtemplates/${templateId}/sections/${sectionId}/elements/${elementId}`
      );
    }
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function reOrderFormSectionElementRequest(
  templateId: string,
  sectionId: string,
  elementId: string,
  index: number,
  isClient: boolean
) {
  try {
    let response;
    if (isClient) {
      response = await axiosInstance.put(
        `${API_BASE_URL}/api/v1/forms/${templateId}/sections/${sectionId}/elements/${elementId}/reorder/${index}`
      );
    } else {
      response = await axiosInstance.put(
        `${API_BASE_URL}/api/v1/formtemplates/${templateId}/sections/${sectionId}/elements/${elementId}/reorder/${index}`
      );
    }
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateBlackOutDateRequest(id: string, payload: any) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/users/${id}/blackout-days`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateBackgroundCheckRequest(
  id: string,
  isCompleted: boolean
) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/users/${id}/background-check?isCompleted=${isCompleted}`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function addFormRequest(payload: any) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/forms`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateFormRequest(formId: string, payload: any) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/forms/${formId}`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateFormDocumentRequest(
  formId: string,
  documentFile: File
) {
  try {
    const formData = new FormData();
    formData.append("form", documentFile);

    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/forms/${formId}/document`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function replaceFormDocumentRequest(
  formId: string,
  documentFile: File
) {
  try {
    const formData = new FormData();
    formData.append("form", documentFile);

    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/forms/${formId}/document/replace`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function addProjectRequest(payload: any) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/projects`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function editProjectRequest(payload: any) {
  const { id } = payload;
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/orders/projects/${id}`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function deleteProjectRequest(id: string) {
  try {
    const response = await axiosInstance.delete(
      `${API_BASE_URL}/api/v1/orders/projects/${id}`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function uploadTempFileRequest(file: File) {
  try {
    const formData = new FormData();
    formData.append("document", file);

    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/files/temporary`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function addOrderRequest(payload: any) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateOrderRequest(orderId: string, payload: any) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/orders/${orderId}`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function createBulkOrdersRequest(formData: FormData) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/bulk`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function addPropertyRequest(payload: any) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/PropertyRecords`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function editPropertyRequest(payload: any) {
  const { id, ...data } = payload;
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/PropertyRecords/${id}`,
      data
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function addOrderIssueRequest(payload: any) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/issues`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function editIssueRequest(issueId: string, payload: any) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/orders/issues/${issueId}`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateIssueRequest(payload: any) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/issues/updates`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function dispatchInvoiceRequest(id: string) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/invoices/${id}/dispatch`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function downloadInvoiceRequest(invoiceIds: string[]) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/invoices/download`,
      {
        invoiceIds,
      },
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response as any;
    }
  }
}

export async function assignInspectorRequest(orderId: string, payload: any) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/${orderId}/inspection/inspector-assign`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function removeAssignedInspectorRequest(orderId: string) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/${orderId}/inspection/inspector-remove`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function acceptOrderRequest(orderId: string) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/${orderId}/inspection/accept`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function rejectOrderRequest(orderId: string, reason: string) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/${orderId}/inspection/reject`,
      {
        reason,
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function deactivateInspectionFirmRequest(id: string) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/inspectors/${id}/deactivate`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function activateInspectionFirmRequest(payload: any) {
  const { id, ...data } = payload;
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/inspectors/${id}/reactivate`,
      data
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function orderValidateRequest(orderId: string) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/${orderId}/validate`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function setAppointmentDateRequest(orderId: string, payload: any) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/${orderId}/appointment`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function sendPasswordResetEmailRequest(userId: string) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/users/${userId}/reset-password`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function duplicateFormTemplateRequest(id: string) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/formtemplates/${id}/duplicate`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function deleteFormTemplatesRequest(formTemplateIds: string[]) {
  try {
    const params = new URLSearchParams();
    formTemplateIds.forEach((id) => {
      params.append("formTemplateIds", id);
    });

    const response = await axiosInstance.delete(
      `${API_BASE_URL}/api/v1/formtemplates?${params.toString()}`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function duplicateFormRequest(id: string) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/forms/${id}/duplicate`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function deleteFormsRequest(formIds: string[]) {
  try {
    const params = new URLSearchParams();
    formIds.forEach((id) => {
      params.append("formIds", id);
    });

    const response = await axiosInstance.delete(
      `${API_BASE_URL}/api/v1/forms?${params.toString()}`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function deleteInsurancePolicy(
  inspectionFirmId: string,
  type: any
) {
  try {
    const response = await axiosInstance.delete(
      `${API_BASE_URL}/api/v1/inspectors/${inspectionFirmId}/insurances/${type}`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function forgotPasswordRequest(payload: { username: string }) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/auth/forgot-password`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateElementAnswerRequest(
  orderId: string,
  elementId: string,
  payload: any
) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/orders/${orderId}/inspection/elements/${elementId}/answers`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function deleteElementAnswerRequest(
  orderId: string,
  elementId: string
) {
  try {
    const response = await axiosInstance.delete(
      `${API_BASE_URL}/api/v1/orders/${orderId}/inspection/elements/${elementId}/answers`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function submitInspectionForm(orderId: string) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/${orderId}/inspection/inspector-submit`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function inspectorReturnRequest(orderId: string) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/${orderId}/inspection/inspector-return`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function qcAssignRequest(payload: any) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/inspection/qc-assign`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function qcRemoveRequest(orderId: string) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/${orderId}/inspection/qc-remove`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function elementApprovalRequest(
  orderId: string,
  elementId: string,
  payload: any
) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/orders/${orderId}/inspection/elements/${elementId}/approval`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function submitQCInspectionForm(orderId: string) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/${orderId}/qc-submit`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function orderUpdateRequest(payload: any) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/updates`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function orderMoveToRecruitingRequest(
  orderId: String,
  payload: any
) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/${orderId}/inspection/recruiting`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function getQCStatusRequest(orderId: String) {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/api/v1/orders/${orderId}/inspection/qcstatus`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateQCStatusRequest(
  orderId: String,
  isSecondQc: boolean,
  isChecked: boolean = false
) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/${orderId}/inspection/qc-complete?isSecondQc=${isSecondQc}&isComplete=${isChecked}`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function orderActionRequest(
  orderId: string,
  action: string,
  payload?: any
) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/${orderId}/${action}`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function reviewOrderRequest(orderId: string) {
  return orderActionRequest(orderId, "review"); // API is still pending
}

export async function validateOrderRequest(orderId: string) {
  return orderActionRequest(orderId, "validate");
}

export async function deleteOrderRequest(orderIds: string[]) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/cancel`,
      {
        orderIds: orderIds,
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateQuickNoteRequest(orderId: String, payload: any) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/${orderId}/quick-note`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function downloadOrderResultRequest(id: string) {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/api/v1/orders/${id}/inspection/result-file`,
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function downloadInspectionResultsRequest(orderIds: string[]) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/inspection/results/download`,
      {
        orderIds,
      },
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (error: any) {
    if (error.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      return json;
    } else {
      return error.response;
    }
  }
}

export async function updateQCModificationRequest(
  orderId: String,
  payload: any
) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/${orderId}/inspection/qc-modification`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function generateFormRequest(id: string) {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/api/v1/orders/${id}/inspection/generate-result`,
      {
        responseType: "blob",
        headers: {
          Accept: "application/zip",
        },
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function uploadFormRequest(orderId: string, file: File) {
  try {
    const formData = new FormData();
    formData.append("form", file);

    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/orders/${orderId}/inspection/result-file`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function deleteFormRequest(orderId: string) {
  try {
    const response = await axiosInstance.delete(
      `${API_BASE_URL}/api/v1/orders/${orderId}/inspection/result-file`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateFormTemplatePhotoOptionsRequest(
  templateId: String,
  payload: any
) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/formtemplates/${templateId}/document/photo-options`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateFormPhotoOptionsRequest(
  formId: String,
  payload: any
) {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/forms/${formId}/document/photo-options`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function downloadTemplateFileRequest(type: string) {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/api/v1/files/template/${type}`
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response as any;
    }
  }
}

export async function approveAllRequest(orderId: string, payload: any) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/orders/${orderId}/inspection/approval`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function exportFormTemplateSectionsRequest(id: string) {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/api/v1/formtemplates/${id}/sections/export`,
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response as any;
    }
  }
}

export async function exportClientFormSectionsRequest(id: string) {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/api/v1/forms/${id}/sections/export`,
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response as any;
    }
  }
}

export async function importFormTemplateSectionsRequest(
  id: string,
  file: File
) {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/formtemplates/${id}/sections/import`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function importClientFormSectionsRequest(id: string, file: File) {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axiosInstance.post(
      `${API_BASE_URL}/api/v1/forms/${id}/sections/import`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}

export async function updateAttachmentsRequest(orderId: string, payload: any) {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/api/v1/orders/${orderId}/attachments`,
      payload
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response;
    }
  }
}
